export const IMG = {
  heroPhone: "/brand/hero-device.webp",
  showcasePhone: "/brand/showcase-dad.webp",
  fullBleedEnergy: "/brand/fullbleed-energy.webp",
};

export const APP_STORE_URL = "https://apps.apple.com/app/source-code";
